// extracted by mini-css-extract-plugin
export default {"sectionContainer":"SearchSection__sectionContainer--2rDcD","buttonWrapper":"SearchSection__buttonWrapper--25ov9"};